import React from 'react';
import { Bell, User } from 'lucide-react';

// The top-level navigation is temporarily hidden for this deployment.
const Header = () => (
  <header className="bg-white shadow-sm border-b border-gray-200 px-6 py-4 flex items-center justify-between relative">
    <div className="flex items-center space-x-3">
      <img src="/logo/logoUF-removebg-preview.png" alt="UF logo" className="h-12 w-auto object-contain" />
      <div className="w-px h-6 bg-gray-300" />
      <img src="/logo/logoMADATLAS-removebg-preview.png" alt="Madatlas logo" className="h-12 w-auto object-contain" />
      <div className="w-px h-6 bg-gray-300" />
      <img src="/logo/logoWNA2-removebg-preview.png" alt="WNA logo" className="h-12 w-auto object-contain" />
      <div className="flex flex-col leading-tight"><h1 className="text-lg font-semibold text-gray-800">WNA</h1></div>
    </div>
    <div className="flex items-center space-x-3">
      <div className="relative cursor-pointer" aria-label="Notifications">
        <Bell className="w-5 h-5 text-gray-600 hover:text-primary" />
        <span className="absolute -top-1 -right-1 bg-primary text-white text-xs px-1.5 rounded-full">3</span>
      </div>
      <div className="flex items-center space-x-2 cursor-pointer hover:bg-gray-100 px-2 py-1 rounded-lg">
        <User className="w-5 h-5 text-gray-600" />
        <span className="text-sm text-gray-600 hidden md:block">Admin</span>
      </div>
    </div>
  </header>
);

export default Header;
